import { Box } from "@mui/material";
import Flex from "../../components/Flex";
import Text from "../../components/Text";
import { DEFAULT_FONTSIZE, replaceUnderScoreAddSpace } from "../../utils/utils";
import {
  FAMILY_HISTORY_SECTION,
  MEDICAL_HISTORY_SECTION,
  SURGICAL_HISTORY_SECTION,
} from "../../utils/subjective-entry";
import EntryLines from "./EntryLines";
import {
  checkNull,
  ListContent,
  ReportContainer,
  sectionHeadStyle,
} from "../constant";

interface HistoryBlockProps {
  data: any;
}

const QuestionerTable = ({ list }: { list: any[] }) => {
  return (
    <table style={{ fontSize: DEFAULT_FONTSIZE.fontSize }}>
      <thead>
        <tr>
          <th>Sr.No. </th>
          <th>Question</th>
          <th>Answer</th>
        </tr>
      </thead>
      <tbody>
        {list?.map((item, index) => {
          const displayAnswer =
            item?.answer === "true" || item?.answer === true
              ? "Yes"
              : item?.answer === "false" || item?.answer === false
                ? "No"
                : item?.answer;

          const questionText =
            typeof item?.question === "object" && item?.question?.question
              ? item.question.question
              : typeof item?.question === "string"
                ? item.question
                : "";

          return (
            <tr key={item?.uuid || index}>
              <td style={{ width: "30px" }}>{index + 1 + "."}</td>
              <td width={"78%"}>{questionText}</td>
              <td>{displayAnswer}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const HistoryBlock = ({ data }: HistoryBlockProps) => {
  const hasHistory =
    checkNull(data?.medicalHistories) ||
    checkNull(data?.surgicalHistory) ||
    checkNull(data?.familyHistories) ||
    checkNull(data?.patientSocialHistory);

  if (!hasHistory) return null;

  return (
    <ReportContainer label="History">
      <Flex flexDirection={"column"} gap={2} mt={1.5} p={1}>
        {checkNull(data?.medicalHistories) && (
          <ReportContainer
            label="Past Medical History"
            fontSize={DEFAULT_FONTSIZE.fontSize}
            color="#f8f1e7"
            borderTop={false}
          >
            <EntryLines
              section={MEDICAL_HISTORY_SECTION}
              rows={data?.medicalHistories}
            />
          </ReportContainer>
        )}

        {checkNull(data?.surgicalHistory) && (
          <ReportContainer
            label="Past Surgical History"
            fontSize={DEFAULT_FONTSIZE.fontSize}
            color="#f8f1e7"
            borderTop={false}
          >
            <EntryLines
              section={SURGICAL_HISTORY_SECTION}
              rows={data?.surgicalHistory}
            />
          </ReportContainer>
        )}

        {checkNull(data?.familyHistories) && (
          <ReportContainer
            label="Family History"
            fontSize={DEFAULT_FONTSIZE.fontSize}
            color="#f8f1e7"
            borderTop={false}
          >
            <EntryLines
              section={FAMILY_HISTORY_SECTION}
              rows={data?.familyHistories}
            />
          </ReportContainer>
        )}

        {checkNull(data?.patientSocialHistory) && (
          <ReportContainer label="Social History">
            <ListContent
              list={Object.keys(data?.patientSocialHistory ?? {})}
              renderItem={(key) => {
                return (
                  <Box mt={1}>
                    <ReportContainer
                      color="#f8f1e7"
                      borderTop={false}
                      label={
                        <Flex
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <Text style={sectionHeadStyle}>
                            {replaceUnderScoreAddSpace(
                              key?.toLowerCase() ?? ""
                            )}
                          </Text>
                        </Flex>
                      }
                    >
                      <QuestionerTable list={data?.patientSocialHistory[key]} />
                    </ReportContainer>
                  </Box>
                );
              }}
            />
          </ReportContainer>
        )}
      </Flex>
    </ReportContainer>
  );
};

export default HistoryBlock;
